module.exports = __webpack_public_path__ + "static/media/empty-image.28f9ea56.png";